const plugin = require("tailwindcss/plugin");
const typography = plugin(({ theme, matchComponents, addUtilities }) => {
  matchComponents(
    {
      headline: (value) => {
        let fontSize = theme(`fontSize.${value}`);
        let fontWeight = theme(`fontWeight.bold`);
        let lineHeight =
          value === "7xl" ? theme("lineHeight.slim") : theme("lineHeight.snug");

        let letterSpacing = (value) => {
          switch (value) {
            case "7xl":
            case "4xl":
              return theme("letterSpacing.tighter");
            case "3xl":
            case "2xl":
              return theme("letterSpacing.tight");
            case "xl":
              return theme("letterSpacing.normal");
            default:
              return "0em";
          }
        };

        return {
          fontSize,
          fontWeight,
          lineHeight,
          letterSpacing: letterSpacing(value),
        };
      },
    },
    {
      values: {
        s: "xl",
        m: "2xl",
        l: "3xl",
        xl: "4xl",
        "2xl": "7xl",
      },
    }
  );
  matchComponents(
    {
      title: (value) => {
        let fontSize = theme(`fontSize.${value}`);
        let fontWeight = theme(`fontWeight.bold`);
        let lineHeight = theme(`lineHeight.normal`);
        return {
          fontSize,
          fontWeight,
          lineHeight,
        };
      },
    },
    {
      values: {
        l: "lg",
        m: "base",
      },
    }
  );
  addUtilities({
    '.break-word-all': {
      'overflow-wrap': 'break-word',
      'word-break': 'break-word',
      hyphens: 'auto',
    },
    '.hyphens-limit-chars': {
      '-moz-hyphenate-limit-chars': '6 3 2',
      '-webkit-hyphenate-limit-chars': '6 3 2',
      'hyphenate-limit-chars': '6 3 2',
      hyphens: 'auto',
    },
  }, ['responsive']);
});

module.exports = typography;
